import { Icon, MinimalIconProps } from '@ardoq/icons';
import { Editor } from '@tiptap/react';
import { ColorPickerButton } from '@ardoq/color-picker';
import { colors } from '@ardoq/design-tokens';
import { createGlobalStyle, css } from 'styled-components';

const UnderlineStyle = createGlobalStyle<{ $underlineColor?: string }>`
  .svg_text_format_underline {
    ${({ $underlineColor }) => css`
      fill: ${$underlineColor};
    `}
  }
`;

const resolveUnderlineColor = (
  currentColor: string,
  isDisabled?: boolean,
  isActive?: boolean
) => {
  if (isDisabled) {
    return colors.textDisabled;
  } else if (isActive) {
    return currentColor;
  }
  return undefined;
};

export const ColorPickerToolbarButton = ({
  tooltipText,
  isDisabled,
  resolveCurrentColor,
  editor,
  icon,
  isActive,
}: {
  tooltipText: string;
  editor: Editor;
  icon: MinimalIconProps;
  resolveCurrentColor: (editor: Editor) => string;
  isDisabled?: boolean;
  isActive?: boolean;
}) => {
  const currentColor = resolveCurrentColor(editor);
  return (
    <ColorPickerButton
      data-tooltip-text={isDisabled ? undefined : tooltipText}
      value={currentColor}
      isDisabled={isDisabled}
      isActive={!isDisabled && isActive}
      isClearable={isActive}
      onClear={() => {
        editor.chain().focus().unsetColor().run();
      }}
      onValueChange={color => {
        editor.chain().focus().setColor(color).run();
      }}
    >
      <UnderlineStyle
        $underlineColor={resolveUnderlineColor(
          currentColor,
          isDisabled,
          isActive
        )}
      />
      <Icon iconName={icon.name} />
    </ColorPickerButton>
  );
};
